import Vpn from './Vpn';

export default Vpn;
